import hexCodes2 from './hexcodes';
import testExclusion from './toggleexclusion';

var highlightStore = [];

const markupContainerId = '#encounter-text-area';
const dataSelector = 'data-cmscode';

const wubwub = {
  // init: initializeWub, // sets jquery selectors
  init: initializeWub,
  highlightEncodings: highlightEncodings, // called after populating encodings[]

  // encodings: [] - set inside of the success handler of page init
  encodings: [], // wubwub.encodings = listItems.map(item => item.code.toString());
  pageKey: 'wubwub',
  hexCodes: hexCodes2,
  setEncodings: function setEncodings(dxes) {
    this.encodings = dxes.map(dx => dx.code.toString());
  },
  isInitialized: false,
  setAsInitialized: function setAsInitialized() {
    this.isInitialized = true;
  },
  setAsUninitialized: function setAsUninitialized() {
    this.isInitialized = false;
  },
  toggleExclusionHighlight
};

/* eslint-disable no-unused-vars */
// this is used elsewhere on the page, do not remove
function setWubWubPageKey() {
  if (wubwub.pageKey === '') {
    wubwub.pageKey = JSON.parse(sessionStorage.MkLayout).sessionInfo.login;
  }
}
/* eslint-enable no-unused-vars */

function highlightEncodings(hexCodes) {
  highlightStore = [];

  var hex = 0;
  // var hexCodes = wubwub.hexCodes;

  // const spanSelector = 'span[' + dataSelector + '="';
  const spanSelector = `span[${dataSelector}="`;

  $.each(wubwub.encodings, function (index, value) {
    const button = $(`button[data-cmscode="${value}"]`);
    const encoding = value;

    // var s = $(markupContainerId).find($(spanSelector + encoding + '"]'));
    const highlights = $(markupContainerId)
      .find($(`${spanSelector}${encoding}"]`));

    // highlights
    $(button).css('background-color', hexCodes[hex]);
    $(button).css('cursor', 'pointer');
    $(highlights).each(function () {
      $(this).css('background-color', hexCodes[hex]);
      $(this).css('cursor', 'pointer');
    });
    hex++;
    if (hex + 1 >= hexCodes.length) {
      hex = 0;
    }

    // highlight cycles
    // magical adjacent identical sibling selector
    var keepGoing = true;
    var currIndex = 0;
    var highlightCollection = [];
    while (keepGoing) {
      var highlightGroup = [];

      // select and grab the first item of the sequence
      // var firstItem = $(spanSelector + encoding + '"]')[currIndex];
      const firstItem = $(`${spanSelector}${encoding}"]`)[currIndex];

      if (!firstItem) {
        return true;
      }

      highlightGroup.push(firstItem);

      var moreItems = true;
      while (moreItems) {
        var nextItem = $(spanSelector + encoding + '"]:eq(' + currIndex + ') + ' + spanSelector + encoding + '"]');
        if (nextItem.length > 0) {
          $.merge(highlightGroup, nextItem);
        } else {
          moreItems = false;
        }
        currIndex++;
      }

      if (currIndex > (highlights.length - 1)) {
        keepGoing = false;
      }

      highlightCollection.push({
        collection: highlightGroup
      });
    }

    highlightStore.push({
      encoding: encoding,
      count: highlightCollection.length,
      currIndex: 0,
      highlightCollection: highlightCollection
    });

    // remove events from previous markup
    $(button).unbind('click');

    $(button).click(function () {
      // broadcast and handle in services/wubwub
      wubBroadcastChannel.postMessage(encoding);
      handleHighlightCycleClick(encoding);
    });
  });
}

function handleHighlightCycleClick(encoding) {
  let objIndex = highlightStore.findIndex(function (item) {
    return item.encoding === encoding;
  });

  // keep this
  if (objIndex === -1) return;

  let hsObj = highlightStore[objIndex];

  var highlightCollection = hsObj.highlightCollection;

  hsObj.currIndex++;

  if (hsObj.currIndex > highlightCollection.length) {
    hsObj.currIndex = 1;
  }

  highlightStore[objIndex] = hsObj;

  const container = $(markupContainerId);
  const item = $(highlightCollection[hsObj.currIndex - 1].collection);

  const grow = {
    'font-size': '+=1px',
    'margin-left': '-=3px',
    'margin-right': '-=3px',
    'margin-top': '+=1px'
  };

  const shrink = {
    'font-size': '-=1px',
    'margin-left': '+=3px',
    'margin-right': '+=3px',
    'margin-top': '-=1px'
  };

  const timeout = 120;

  container.animate({
    scrollTop: (
      item.offset().top -
      container.offset().top -
      (container.height() / 2))
      + container.scrollTop()
  }, 'slow', function () {
    item.animate(grow, timeout)
      .animate(shrink, timeout)
      .animate(grow, timeout)
      .animate(shrink, timeout)
      .animate(grow, timeout)
      .animate(shrink, timeout);
  });
}

function toggleExclusionHighlight() {
  const exclusionsActive = $(this).data('active');

  if (exclusionsActive) {
    $('.exclusion-highlight').each(function () {
      $(this).removeClass('exclusion-highlight');
      $(this).addClass('exclusion-highlight-none');
    });

    $(this).data('active', false);
  } else {
    $('.exclusion-highlight-none').each(function () {
      $(this).removeClass('exclusion-highlight-none');
      $(this).addClass('exclusion-highlight');
    });

    $(this).data('active', true);
  }
}

/* BroadcastChannel stuff */
let wubBroadcastChannel = new BroadcastChannel(wubwub.pageKey);

wubBroadcastChannel.onmessage = function (ev) {
  handleHighlightCycleClick(ev.data);
};

function initializeWub() {
  $('#highlightToggle').unbind('click');
  $('#exclusionToggle').unbind('click');

  $('#highlightToggle')
    .click(handleHighlightToggle)
    .attr('data-active', true);

  $('#exclusionToggle')
    .click(toggleExclusionHighlight)
    // .click(testExclusion)
    .attr('data-active', false);

    // $('#exclusionToggle').click();

  $('<style>.exclusion-highlight { color: red; }</style>')
    .appendTo(document.head);
}

function handleHighlightToggle() {
  const highlightsActive = $(this).data('active');

  if (highlightsActive) {
    wubwub.highlightEncodings(['transparent']);
    $(this).data('active', false);
  } else {
    wubwub.highlightEncodings(wubwub.hexCodes);
    $(this).data('active', true);
  }
}

export default wubwub;
